module.exports = __webpack_public_path__ + "img/scholar4.31e239d2.png";